export const DEFAULT_STORE = 'web';
export const BACKEND_STORE_PREFIX = 'fashion_';
